/**
 * Format a Date as a `YYYY-MM-DD` string using its LOCAL calendar fields.
 *
 * Use this for date-only wire values derived from a date picker. `Date.toISOString().slice(0,10)`
 * is wrong here: the picker yields a local-midnight Date, and `toISOString()` shifts it to UTC
 * first — so for a user east of UTC (e.g. BST) local midnight becomes the previous day in UTC and
 * the wire date is off by one. Reading the local fields keeps the wire date equal to the day the
 * user clicked.
 */
export function toLocalIsoDate(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
